var $1d5c42d075697aa9$exports = {};
$1d5c42d075697aa9$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B} \u{442}\u{440}\u{438}\u{432}\u{43E}\u{433}\u{438}`,
    "dismiss": `\u{421}\u{43A}\u{430}\u{441}\u{443}\u{432}\u{430}\u{442}\u{438}`
};


export {$1d5c42d075697aa9$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
